import React from 'react';
import {StyledIcon, IconWrapper} from './styles';

function ChecklistOptionBinaryBagde({value}) {
  return (
    <IconWrapper data-testid="binary-badge" value={value}>
      <StyledIcon value={value} />
    </IconWrapper>
  );
}

export default ChecklistOptionBinaryBagde;
